module.exports = __webpack_public_path__ + "static/media/BF.facb7554.png";